<template>
  <div class="is-hidden-mobile" data-track="Review Invites Analytics view">
    <!-- Header Section Begins -->
    <div class="level page-info-section">
      <div class="level-left">
        <b>Review Invites</b>
      </div>
      <div class="level-right">
        <date-select-filter
          class="custom-dropdown"
          data-track="Review Invites Analytics change date"
          :filter_items="filters.dateFilter.props"
          :styleProp="filters.dateFilter.styleProp"
          @onDateChange="handleDateChange"
        />
        <a
          data-track="Review Invites Analytics export"
          class="button is-hidden-mobile"
          :href="exportReviews"
          :disabled="!isPaidUser"
        >EXPORT</a>
        <a
          data-track="Review Invites Analytics export"
          class="button is-hidden-tablet is-fullwidth"
          :href="exportReviews"
          :disabled="!isPaidUser"
        >EXPORT</a>
      </div>
    </div>
    <!-- Header Section Ends -->
    <hr class="horizontal-row" />
    <!-- Tabs Section Starts-->
    <div class="custom-tabs">
      <div class="tabs is-boxed custom-tabs__tab-box">
        <ul class="custom-tabs__group">
          <!-- Review Invites Tab Begins -->
          <li :class="{'is-active': isActiveTab('invites')}">
            <router-link class="custom-tabs__link" to="/analytics/invites">
              <span class="custom-tabs__text">Review invites</span>
            </router-link>
          </li>
          <!-- Review Invites Tab Ends -->
          <!-- Conversion Rate Tab Begins -->
          <li :class="{'is-active': isActiveTab('conversions')}">
            <router-link class="custom-tabs__link" to="/analytics/invites/conversions" exact>
              <span class="custom-tabs__text">Conversion rate</span>
            </router-link>
          </li>
          <!-- Conversion Rate Tab Ends -->
        </ul>
      </div>
      <div class="custom-tabs__content-box">
        <router-view></router-view>
      </div>
    </div>
    <!-- Tabs Section Ends-->
    <!-- Stats Card Begins -->
    <div class="columns stats-card-section">
      <span class="column is-one-third level email-invite-sent stats-card">
        <!-- Email Header Section Begins -->
        <div class="info-header">
          <div class="emails">
            <span class="level-item is-pulled-left is-inline-block">
              <img src="/static/img/analytics/envelop.svg" alt="envelop" />
            </span>
            <span class="level-item is-pulled-left is-inline-block">
              <span class="text">
                Email review invites&nbsp;
                <b>sent</b>
              </span>
            </span>
          </div>
          <div
            class="level-item is-pulled-right count"
          >{{analyticsData.stats.emailInvites || 0 | formatDigit}}</div>
        </div>
        <!-- Email Header Section Ends -->
        <span class="section-divider">
          <hr />
        </span>
        <!-- Email Statistics Begins -->
        <div class="level statistics">
          <div class="level-item level-left opens">Opens</div>
          <div class="level-item">
            <progress
              max="100"
              class="progress is-inmail"
              :value="calculateRate(analyticsData.stats.opened, analyticsData.stats.emailInvites)"
            >88&#37;</progress>
          </div>
          <div class="level-item level-right numbers">
            <animated-number
              class="counts"
              round="1"
              :duration="500"
              :value="analyticsData.stats.opened"
              :formatValue="formatStats"
            ></animated-number>
            <span class="percent">|</span>
            <animated-number
              class="counts-percentages"
              round="1"
              :duration="500"
              :value="calculateRate(analyticsData.stats.opened, analyticsData.stats.emailInvites)"
              :formatValue="formatStats"
            ></animated-number>%
          </div>
        </div>
        <div class="level statistics">
          <div class="level-item level-left opens">Clicks</div>
          <div class="level-item">
            <progress
              max="100"
              class="progress is-inmail"
              :value="calculateRate(analyticsData.stats.clicked, analyticsData.stats.emailInvites)"
            >35&#37;</progress>
          </div>
          <div class="level-item level-right numbers">
            <animated-number
              class="counts"
              round="1"
              :duration="500"
              :value="analyticsData.stats.clicked"
              :formatValue="formatStats"
            ></animated-number>
            <span class="percent">|</span>
            <animated-number
              class="counts-percentages"
              round="1"
              :duration="500"
              :value="calculateRate(analyticsData.stats.clicked, analyticsData.stats.emailInvites)"
              :formatValue="formatStats"
            ></animated-number>%
          </div>
        </div>
        <div class="level statistics">
          <div class="level-item level-left opens">Conversions</div>
          <div class="level-item">
            <progress
              max="100"
              class="progress is-inmail"
              :value="calculateRate(analyticsData.stats.emailConverted, analyticsData.stats.emailInvites)"
            >43&#37;</progress>
          </div>
          <div class="level-item level-right numbers">
            <animated-number
              class="counts"
              round="1"
              :duration="500"
              :value="analyticsData.stats.emailConverted"
              :formatValue="formatStats"
            ></animated-number>
            <span class="percent">|</span>
            <animated-number
              class="counts-percentages"
              round="1"
              :duration="500"
              :value="calculateRate(analyticsData.stats.emailConverted, analyticsData.stats.emailInvites)"
              :formatValue="formatStats"
            ></animated-number>%
          </div>
        </div>
        <!-- Email Statistics Ends -->
      </span>
      <!-- SMS Statistics Begins -->
      <span class="column is-one-third sms-invite-sent stats-card">
        <div class="info-header">
          <div class="emails">
            <span class="level-item is-pulled-left is-inline-block">
              <img src="/static/img/analytics/sms.svg" alt="envelop" />
            </span>
            <span class="level-item is-pulled-left is-inline-block">
              <span class="text">
                SMS review invites&nbsp;
                <b>sent</b>
              </span>
            </span>
          </div>
          <div
            class="level-item is-pulled-right count"
          >{{analyticsData.stats.smsInvites || 0 | formatDigit}}</div>
        </div>
        <span class="section-divider">
          <hr />
        </span>
        <div class="level statistics">
          <div class="level-item level-left opens">Conversions</div>
          <div class="level-item">
            <progress
              max="100"
              class="progress is-sms"
              :value="calculateRate(analyticsData.stats.smsConverted, analyticsData.stats.smsInvites, false)"
            >87&#37;</progress>
          </div>
          <div class="level-item level-right numbers">
            <animated-number
              class="counts"
              round="1"
              :duration="500"
              :value="analyticsData.stats.smsConverted"
              :formatValue="formatStats"
            ></animated-number>
            <span class="percent">|</span>
            <animated-number
              round="1"
              :duration="500"
              :value="calculateRate(analyticsData.stats.smsConverted, analyticsData.stats.smsInvites, false)"
              :formatValue="formatStats"
            ></animated-number>%
          </div>
        </div>
      </span>
      <!-- SMS Statistics Ends -->
    </div>
    <!-- Stats Card  Ends-->
  </div>
</template>

<script>
/* eslint-disable indent,no-new,no-undef,valid-jsdoc,one-var */
import moment from 'moment'
import misc from '@/mixins/graphs.js'
import Rating from '@/components/Rating'
import { mapState, mapActions } from 'vuex'
import { DateSelectFilter } from '@/components'
import AnimatedNumber from 'animated-number-vue'
import InviteTab from '@/pages/analytics/invites/InviteTab'
import ConversionRateTab from '@/pages/analytics/invites/ConversionRateTab'
import { FETCH_REVIEW_INVITE_ANALYTICS_STATS } from '@/store/action.types'

export default {
  name: 'ReviewInvites',
  metaInfo: {
    title: 'Business Portal | Hellopeter - Review Invites Analytics'
  },
  mixins: [misc],
  components: {
    Rating,
    InviteTab,
    AnimatedNumber,
    DateSelectFilter,
    ConversionRateTab
  },
  data () {
    return {
      isActiveItem: 'invites',
      userInfo: JSON.parse(localStorage.getItem('billingDetails')),
      businessSlug: localStorage.getItem('org_slug'),
      filters: {
        starRating: null,
        dateFilter: {
          label: 'last_6_months',
          endDate: null,
          startDate: null,
          styleProp: {},
          props: [
            {
              name: 'date',
              label: 'Date',
              showApplyBtn: true,
              default: { type: 'months', value: 6, selected: 'Last 6 months' }, // moment.js placeholder in type
              disabled: [],
              elements: [
                'Last 7 days',
                'Previous month',
                'Last 6 months',
                'Last 12 months',
                'Custom'
              ]
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapState({
      analyticsData: state => state.analytics.reviewInvites
    }),
    /**
     * Checking if a user is a paid user
     * @return {boolean}
     */
    isPaidUser () {
      return (
        this.userInfo.subscription.name !== 'Free'
      )
    },
    /**
     * Creating a payload for HTTP request
     * @return {object}
     */
    payload () {
      return {
        label: this.customLabel,
        endDate: this.filters.dateFilter.endDate,
        startDate: this.filters.dateFilter.startDate,
        businessSlug: this.businessSlug
      }
    },
    /**
     * Get label for date dropdown
     * @return {string}
     */
    customLabel () {
      let customLabel = ''
      let startDate = moment(this.filters.dateFilter.startDate),
        endDate = moment(this.filters.dateFilter.endDate)
      let dateDiff = endDate.diff(startDate, 'days')
      switch (true) {
        case dateDiff <= 7:
          customLabel = 'last_7_days'
          break
        case dateDiff > 7 && dateDiff <= 31:
          customLabel = 'previous_month'
          break
        case dateDiff > 31 && dateDiff <= 183:
          customLabel = 'last_6_months'
          break
        case dateDiff > 183:
          customLabel = 'last_12_months'
          break
      }
      return customLabel
    },
    /**
     * Get link to export review analytics data
     * @return {string}
     */
    exportReviews () {
      if (this.isPaidUser) {
        return (
          process.env.API_URL +
          `/marketing/${this.businessSlug}/export-review-invitation-history?
          startDate=${this.filters.dateFilter.startDate}&
          endDate=${this.filters.dateFilter.endDate}&
          token=${localStorage.getItem('auth_token')}
          `
        )
      }
    }
  },
  created () {
    this.setUpgradedPackage()
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Review Invites Analytics'
    })
  },
  methods: {
    ...mapActions({
      fetchReviewInvitesAnalytics: `analytics/${FETCH_REVIEW_INVITE_ANALYTICS_STATS}`
    }),
    /**
     * If user having to Free/Lite package
     * @return {void}
     */
    setUpgradedPackage () {
      /** If user having Free package, set default filter to previous months */
      if (this.userInfo.subscription.name === 'Free') {
        this.filters.dateFilter.styleProp = 'height: 224px;'
        this.filters.dateFilter.props[0].default.value = 1
        this.filters.dateFilter.props[0].default.selected = 'Previous month'
        this.filters.dateFilter.props[0].disabled = [
          'Last 6 months',
          'Last 12 months',
          'Custom'
        ]
        this.filters.dateFilter.props[0].showApplyBtn = false
      }
    },
    /**
     * Fetching the review analytics stats
     * @return {void}
     */
    fetchAnalyticsStats () {
      this.fetchReviewInvitesAnalytics(this.payload)
    },
    /**
     * Handle Date Dropdown Filter
     * @param {object} dateFilter Date data to sort on
     * @return {void}
     */
    handleDateChange (dateFilter) {
      Object.assign(this.filters.dateFilter, dateFilter)
      this.fetchAnalyticsStats()
      this.$emit('onDateChangeForInvites', dateFilter)
      this.$emit('onDateChangeForConversions', dateFilter)
    },
    /**
     * Check the active tab
     * @param {string} tab Checking tab to show active
     * @return {boolean}
     */
    isActiveTab (tab) {
      return this.$router.currentRoute.name.toLowerCase() === tab
    },
    /**
     * Calculate rate with rounded digits
     * @param {number} value Value of stat
     * @param {number} total Total count of stat
     * @return {number}
     */
    calculateRate (value, total, includeBounced = true) {
      let bounced = !includeBounced ? 0 : this.analyticsData.stats.bounced,
        rate = (value * 100) / (total - bounced)
      return !isNaN(rate) ? rate : 0
    },
    /**
     * Format the float numbers upto two digits after decimal
     * @param {string} value Value of stat
     * @return {string|number}
     */
    formatStats (value) {
      return !Number.isInteger(value) ? `${Number(value).toFixed(2)}` : value
    }
  },
  filters: {
    /**
     * Format the integer by separator (comma (,)) after three digits (e.g 1,530)
     * @param val
     * @return {string}
     */
    formatDigit (val) {
      return val.toLocaleString()
    }
  }
}
</script>

<!-- Local CSS Begins -->
<style scoped>
.level .level-right a {
  width: 130px;
  height: 37px;
  color: #58595b;
  border-radius: 2px;
  border: solid 1px #58595b;
}
.horizontal-row {
  margin-top: 0;
  margin-bottom: 1rem;
  margin-left: -5%;
  margin-right: -5%;
}
.page-info-section {
  position: relative;
  margin-bottom: 0.7rem;
}
.page-info-section .level-right .padding-bottom-0 {
  width: 302px;
  padding: 0;
  margin-right: 15px;
}
.page-info-section .dropdown-trigger button {
  padding-left: 20px !important;
}
.email-invite-sent {
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
}
.sms-invite-sent {
  border: solid 1px rgba(88, 89, 91, 0.32);
  background-color: #ffffff;
}
/* Tabs CSS Begins */
.custom-tabs__tab-box {
  margin-bottom: -1px;
}
.custom-tabs__group {
  border: none;
}
.tabs.is-boxed a.custom-tabs__link {
  border: 1px solid rgba(88, 89, 91, 0.32);
  border-radius: 0;
  width: 193px;
  height: 45px;
  padding: 0;
  margin-right: 5px;
}
.tabs.is-boxed a.custom-tabs__link:hover {
  background-color: unset;
}
.tabs.is-boxed li.is-active a.custom-tabs__link {
  background-color: #fafafa;
}
.custom-tabs__text {
  opacity: 0.5;
  font-size: 11px;
  color: #58595b;
}
.is-active .custom-tabs__text {
  opacity: 1;
  color: #30aae1;
}
.custom-tabs__content-box {
  border: 1px solid rgba(88, 89, 91, 0.32);
  background-color: #fafafa;
}
/* Tabs CSS Ends */
.stats-card-section {
  margin-top: 15px;
}
.stats-card .text {
  color: #58595b;
  font-size: 12px;
  line-height: 4px;
  padding-left: 10px;
}
.stats-card .count {
  color: #4d4f5c;
  font-size: 24px;
  margin-top: -2%;
  font-weight: bold;
}
.stats-card .info-header .emails {
  margin-top: 2%;
}
.sms-invite-sent {
  height: 123px;
  margin-left: 15px;
}
.section-divider hr {
  margin: 3rem 0 1rem 0;
  display: flex;
  background-color: #e8e9ec;
}
.statistics .numbers {
  padding: 0;
  color: #4d4f5c;
  font-size: 12px;
  font-weight: bold;
}
.statistics .numbers .counts,
.counts-percentages {
  width: 30px;
  text-align: right;
}
.statistics .numbers .counts-percentages {
  width: 14px;
  text-align: right;
}
.statistics .numbers .percent {
  color: rgba(88, 89, 91, 0.32);
  margin: 0 5px 0 10px;
}
.progress::-webkit-progress-value {
  transition: width 0.8s ease;
}
.statistics .progress {
  width: 145px;
  height: 10.5px;
  border-radius: 0;
}
.statistics .opens {
  font-size: 12px;
  font-weight: bold;
  color: #4d4f5c;
}
.statistics .level-left {
  width: 75px;
}
/* INMAIL PROGRESS BAR*/
.progress.is-inmail::-webkit-progress-value {
  background-color: #6a4ee4;
}
.progress.is-inmail::-moz-progress-bar {
  background-color: #6a4ee4;
}
.progress.is-inmail::-ms-fill {
  background-color: #6a4ee4;
}
/* INMAIL PROGRESS BAR*/
.progress.is-sms::-webkit-progress-value {
  background-color: #82cced;
}
.progress.is-sms::-moz-progress-bar {
  background-color: #82cced;
}
.progress.is-sms::-ms-fill {
  background-color: #82cced;
}
/* Invites CSS Ends */

/* Media Queries begins */
/* Media Query For Tablet */
@media screen and (min-width: 767px) {
  .email-invite-sent {
    width: 50%;
  }
  .sms-invite-sent {
    width: 47.8%;
  }
}
@media (min-width: 1366px) {
  .email-invite-sent {
    width: 33.33%;
  }
  .sms-invite-sent {
    width: 33.33%;
  }
}
/* Media Query For Desktop and Big Screens */
@media screen and (min-width: 1280px) {
  .email-invite-sent {
    width: 33.33%;
  }
  .sms-invite-sent {
    width: 33.33%;
  }
}
/* Media Queries ends */

.custom-dropdown >>> .button.button-dropdown span {
  margin-left: 36px !important;
}

.custom-dropdown >>> .button.button-dropdown {
  padding: 0px 50px 0px 20px !important;
}
</style>
<!-- Local CSS Ends -->
<!-- Global CSS Begins -->
<style>
div#sideBar .is-padding-top-0 {
  padding-top: 0;
}

.page-info-section .fa-angle-down {
  font-size: 1.5em !important;
}

.page-info-section .fa-angle-down:before {
  right: 1.3em !important;
  border: 3px solid #95979b !important;
  border-right: 0 !important;
  border-top: 0 !important;
}

@media screen and (min-width: 768px) {
  div#sideBar main.column.main-column {
    width: 83%;
  }
}
</style>
<!-- Global CSS Ends -->



// WEBPACK FOOTER //
// src/pages/analytics/invites/ReviewInvites.vue